import "./Workshop.css";
import Photo from "./photo.png";

const Workshop = () => {

    return (<div className="workshop-main">

        <img className="workshop-photo" src={Photo} alt="img" />

        <div className="wm-2" >
            <p style={{ marginTop: "50px" }} className="admission-txt" >Upcoming Event</p>

            <h1>Building children <br />one at a time</h1>

            <p className="admission-sub-txt" >Coolness flows from the Fountains <br />of Knowledge</p>

            <div style={{ display: "flex" }}>

                <div className="wm-event-date" >

                    <i class="fa-solid fa-calendar"></i>

                    <span>07 Aug 2025</span>

                </div>

                <div className="wm-event-date" style={{ marginLeft: "100px" }} >

                    <i style={{ padding: "10px" }} class="fa-solid fa-clock"></i>

                    <span>07:30 PM</span>

                </div>
            </div>

        </div>

    </div>)

}

export default Workshop;